import { render } from "./WebsiteGroup.vue?vue&type=template&id=73fed174"
import script from "./WebsiteGroup.vue?vue&type=script&lang=js"
export * from "./WebsiteGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__